import React, { useState } from 'react';
import classNames from 'classnames';
import Link from 'next/link';
import { i18n as I18n } from '../../../utils/i18n';

interface Props {
  question: string;
  answer: string;
  roomTypes?: object;
  introText?: string;
  endText?: string;
  listItems?: Array<string>;
  formattedText?: boolean;
  hyperlinks?: Array<object>;
  hyperlinksIntroText: string;
}

const FrequentlyAskedQuestionsItems: React.FC<Props> = ({
  question,
  answer,
  roomTypes,
  introText,
  endText,
  listItems,
  formattedText,
  hyperlinks,
  hyperlinksIntroText,
}) => {
  const [currentAnswerIsShow, toggleAnswer] = useState(false);

  const buttonClasses = classNames({
    button: true,
    'button--text': true,
    'button--close': currentAnswerIsShow,
    'button--open': !currentAnswerIsShow,
  });

  const renderAnswerToggle = () => {
    return (
      <button
        data-testid="toggleAnswer"
        className={buttonClasses}
        onClick={() =>
          toggleAnswer(currentAnswerIsShow => {
            return !currentAnswerIsShow;
          })
        }
        key={question}
      >
        {question}
      </button>
    );
  };

  const textWithHyperlink = (url, name) => {
    return (
      <Link href={url}>
        <a target="_blank" rel="noopener noreferrer">
          {name}
          &nbsp;
        </a>
      </Link>
    );
  };

  const renderRoomTypes = () => {
    return (
      roomTypes && (
        <>
          <h4>{I18n.t('shared.clinical')}</h4>
          <ul>
            {roomTypes.clinical.map(clinical => {
              return <li key={clinical}>{clinical}</li>;
            })}
          </ul>
          <br />
          <h4>{I18n.t('shared.non_clinical')}</h4>
          <ul>
            {roomTypes.nonClinical.map(nonClinical => {
              return <li key={nonClinical}>{nonClinical}</li>;
            })}
          </ul>
        </>
      )
    );
  };

  const renderAnswer = () => {
    return (
      currentAnswerIsShow &&
      answer && (
        <>
          <p key={answer}>{answer}</p>
          {renderRoomTypes()}
        </>
      )
    );
  };

  const renderFormattedAnswer = () => {
    return (
      currentAnswerIsShow &&
      formattedText && (
        <>
          <p key={introText}>{introText}</p>
          <ul className="faq__formatted-list">
            {listItems.map(item => {
              return <li key={item}>{item}</li>;
            })}
          </ul>
          {hyperlinksIntroText && (
            <p className="faq__inline">{hyperlinksIntroText}</p>
          )}
          {roomTypes && renderRoomTypes()}
          {hyperlinks && (
            <>
              &nbsp;
              {textWithHyperlink(hyperlinks[0].url, hyperlinks[0].name)}
              {textWithHyperlink(hyperlinks[1].url, hyperlinks[1].name)}
              <p className="faq__inline">{I18n.t('shared.and')}</p>
              &nbsp;
              {textWithHyperlink(hyperlinks[2].url, hyperlinks[2].name)}
            </>
          )}
          {endText && <p>{endText}</p>}
        </>
      )
    );
  };

  return (
    <>
      {renderAnswerToggle()}
      {formattedText ? renderFormattedAnswer() : renderAnswer()}
    </>
  );
};

export default FrequentlyAskedQuestionsItems;
